module.exports = __webpack_public_path__ + "static/media/info-3.bcd1db11.jpg";